import React from 'react';

const ReverseTile = (props) => {
    const { link, content } = props;
    return (
        <a className="viewBusesRoute cpointer" href={link}>
            <span className="marginRight30">{content}</span>
            <span className="rightArrow"></span>
        </a>
    )
}

export default ReverseTile;
